import { Button, Flex, Label } from "@braze/beacon-core";
import { getFontFamily } from "@braze/beacon-styling";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { NavTabs } from "../navbar";
import { useEffect, useState } from "react";
import api from "../../util/axios";
import { SignInBlock } from "../login/SignInBlock";
import { LoginCallback, useOktaAuth } from "@okta/okta-react";
import { UserClaims } from "@okta/okta-auth-js";
import { ViewContainer } from "../../shared/ViewContainer";
import { Background } from "../../shared/Background";
import { JiraMigrationBanner } from "../../shared/JiraMigrationBanner";



export const MainLayout = ({ children } : React.PropsWithChildren<{}>) => {
    const navigate = useNavigate();
    const homePage = () => navigate("/");

    const { oktaAuth, authState } = useOktaAuth();
    const [userInfo, setUserInfo] = useState<UserClaims>();
    oktaAuth.getAccessToken();

    const login = async () => oktaAuth.signInWithRedirect({});
    const logout = async () => {
      	oktaAuth.signOut({
        	postLogoutRedirectUri: "/", 
			revokeAccessToken: false
      	});
      	document.location.reload();
    };

    useEffect(() => {
      if (!authState?.isAuthenticated) {
        setUserInfo(undefined);
      } else {
        oktaAuth.getUser().then((info) => {
          setUserInfo(info);
          localStorage.setItem("user", JSON.stringify(info));
        });
      }
      
    }, [oktaAuth, authState])


    if (window.location.hash) {
      return <LoginCallback />;
    }

    if (!authState?.isAuthenticated) {
      return (
        <SignInBlock login={login}/>
      )
    }

    
    return (
        <AppContainer id="appcontainer">
            <Header>
              <NavMenu>
                <Flex>
                  <img
                    src="/img/anvil.png"
                    alt="anvil-logo"
                    onClick={homePage}
                    style={{ cursor: "pointer"}}
                  />
                  <LogoText alignItems="center" direction="column">
                    <Label onClick={homePage}>Braze Builder</Label>
                  </LogoText>
                </Flex>
                <Button onClick={logout}>Sign Out</Button>
              </NavMenu>
              
              {/* <NavTabs/> */}
            </Header>
              
              <Main id="maincontainer">
                  <Background>
                    <ViewContainer>
                      <JiraMigrationBanner />
                      <NavTabs/>
                      {children}
                    </ViewContainer>
                  </Background>
                  
                  
              </Main>
        </AppContainer>
    )
}


const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  min-width: 680px;
  background: #f8f8f8;
  font-family: ${getFontFamily("base")};
`;

const Header = styled(Flex)`
    background: #ffffff;
    padding: 0 4rem;
    // box-shadow: 0px 12px 24px rgba(69, 84, 94, 0.1);
    z-index: 200;
    flex-direction: column;
`;

const Main = styled(Flex)`
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: scroll;
`;

const NavMenu = styled(Flex)`
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  // cursor: pointer;
  img {
    height: 55px;
    padding-left: 2rem;
  }
  font-family: ${getFontFamily("base")};
`;

const LogoText = styled(Flex)`
  margin-left: 1rem;
  margin-top: 1rem;
  img {
    width: 70px;
    height: 25px;
    padding-right: -1rem;
  }
  Label {
    color: #2e3c47;
    font-size: 34px;
    letter-spacing: -0.75px;
    line-height: 40px;
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    cursor: pointer;
  }
`;